// components/ClosingBlock.jsx
import { useMemo } from "react";
import { getRandomVariant } from "./getRandomVariant";

const closingVariants = [
  ({ company }) => (
    <>
      These financial ratios collectively offer a structured view of <strong>{company}</strong> across valuation, performance, and financial structure.
    </>
  ),

  ({ company }) => (
    <>
      By reviewing these ratios together, investors can track changes in <strong>{company}</strong>'s financial profile over time.
    </>
  )
];

export default function ClosingBlock({ company }) {
  const Variant = useMemo(
    () => getRandomVariant(closingVariants),
    []
  );

  return (
    <p className="mb-8">
      <Variant company={company} />
    </p>
  );
}
